import { Button } from '@raspberrypifoundation/design-system-react'
import { useTranslation } from 'react-i18next'

import PageSection from 'components/shared/PageSection/PageSection'
import ChallengeImage from 'components/Homepage/images/challenge.svg'

import './ChallengesSection.scss'

export const ChallengesSection = () => {
  const { t } = useTranslation()

  return (
    <PageSection id="challenge" className="c-challenges-section">
      <div className="c-challenges-section__content">
        <div className="c-challenges-section__content__info">
          <div className="c-challenges-section__content__info__title">
            {t('homepage.challenges.title')}
          </div>
          <p className="c-challenges-section__content__info__paragraph">
            {t('homepage.challenges.paragraph1')}
          </p>
          <p className="c-challenges-section__content__info__paragraph">
            {t('homepage.challenges.paragraph2')}
          </p>

          <div>
            <Button
              className="c-challenges-section__content__button"
              textAlways
              type="primary"
              icon="open_in_new"
              iconPosition="right"
              text={t('homepage.challenges.button')}
              href="https://codeclub.org/en/challenges-july?utm_source=projects&utm_medium=homepage&utm_campaign=challenges"
            />
          </div>
        </div>
        <div className="c-challenges-section__image-container">
          <img
            src={ChallengeImage}
            alt={t('homepage.challenges.title')}
            className="c-challenges-section__image-container__element"
          />
        </div>
      </div>
    </PageSection>
  )
}

ChallengesSection.propTypes = {}

export default ChallengesSection
